export const getUserId = (user) => {
    return user && user.userId;
}

export const getPinInSession = (user) => {
    const UserId = getUserId(user);
    
    if(!UserId) return;   

    return sessionStorage.getItem(UserId) ? sessionStorage.getItem(UserId): '';
}

export const setPinInSession = (getPin, user) => { 
    const UserId = getUserId(user);
    
    if(!UserId) return;  

    if(getPin) {
       return getPinInSession(user) ? '' : sessionStorage.setItem(UserId, getPin);
    }
}